import React from 'react';
import {Link} from 'react-router';
import { connect } from 'react-redux'
import '../login.css';
import Paper from 'material-ui/Paper';
import logo from '../images/medefy-logo.png';
//import {logoutUser}  from '../actions/authActions'


const style = {
  minHeight: 400,
  height: 'auto',
  minWidth: 275,
  width: 'auto',
  marginTop: 100,
  padding:15,
  textAlign: 'center'
};

const styleButton = {
 marginBottom:15
};


class LogoffPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: ""
    };

    

  }

  componentDidMount(){
      this.props.logout();
  }
  

  render() {

    return (
        <div className="container">
            <div className="row">
                <div className="col-md-6">
                    <Paper style={style} zDepth={3} >
                        <img src={logo} alt="Medefy" />
                        <br />
                        <br />
                        <h2>Logoff successful.</h2>
                        <br />
                        <Link to={"/"} style={styleButton} >Return to Login Page</Link> 
                    </Paper>
                </div>
            </div>
        </div>
    );
  }

};


const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => {
      //dispatch(logoutUser())
    }
  }
}

const mapStateToProps = (state) => ({
    member: state.thisApp.member
})


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LogoffPage)

//export default LogoffPage;


// WEBPACK FOOTER //
// ./src/Pages/Logoff.js